module.exports = __webpack_public_path__ + "assets/images/ShadeBlue.b5ba02e86d69d1b377b282e4c760a6d0.png";